<template>
  <div>
      活动分析
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>